import React, { Component } from 'react';

class Date extends Component {
  render() {
    const { value } = this.props;
    let result = '';
    if (value && value.toLocaleDateString) {
      result = value.toLocaleDateString('nl-NL');
    }

    return (
      <span>
        {result}
      </span>
    );
  }
}

export default Date;



// WEBPACK FOOTER //
// ./src/shared/Date.js